import React from 'react';

// Components
import * as S from './Styled';

const MainWrapper = ({ children, ...rest }) => (
  <S.MainWrapper {...rest}>{children}</S.MainWrapper>
);

export default MainWrapper;
